import { ALLOW_EDIT } from '../../../utils/OperationPermissions';

const PurchaseReconciliation = {
  type: 'MinMaxCalculationParametersInput',
  formTitle: 'Purchase Reconciliation',
  formUrl: '/Suppliers/Reconciliation/',
  screenReference: 'SUPPLIER_RECONCILIATION',
  operations: ALLOW_EDIT,
};

export default PurchaseReconciliation;
